import { SMSDataType, SMSSortField } from 'types/sms.type';
import axiosInstance from './config/api';
import { SortDirection } from 'types/call.type';

export type SMSDataParams = {
    perPage?: number;
    currentPage?: number;
    id?: string;
    sortOrder?: SortDirection;
    sortBy?: SMSSortField;
    search?: string;
    smsStatus?: string;
    nodeStatus?: string;
    conversationState?: string;
    nodeSubStatus?: string;
    partyStage?: string;
    startDate?: Date;
    endDate?: Date;
    overDue?: boolean;
};

export type SMSDataResponse = {
    data: SMSDataType[];
    pagination: {
        totalPages: number;
        totalRecords: number;
        currentPage: number;
        perPage: number;
    };
};

export const getSMSData = async ({ id, ...rest }: SMSDataParams) => {
    const params = {
        ...rest,
        workflowId: id,
    };
    return await axiosInstance.get<SMSDataResponse>('/sms', { params }).then((res) => res.data);
};
